import Message from './Message.vue';
import { createApp,nextTick } from 'vue'

Message.install = function(options, type) {
	if (options === undefined || options === null) {
		options = {
			content: '',
		};
	} else if (typeof options === 'string' || typeof options === 'number') {
		options = {
			content: options,
		};
		if (type != undefined && options != null) {
			options.type = type;
		}
	}

	let instance = createApp(Message).mount('body')

	nextTick(() => {
		instance.visible = true;
	});
};

export default Message;
